export const version = "web/5.0.13";
//# sourceMappingURL=_version.js.map